import React from "react";

const OhlPin = ({ color = "black" }) => {
    return (
        <svg
            id="leaflet-marker-icon"
            width="40"
            height="40"
            viewBox="0 0 257 218"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_6_29)">
                <path
                    d="M128.364 214.471C140.628 202.46 188.954 140.689 205.292 96.7031C209.842 86.5545 211.534 75.6444 210.232 64.8429C208.93 54.0413 204.67 43.6474 197.792 34.4903C190.914 25.3331 181.608 17.6661 170.617 12.1008C159.626 6.53559 147.254 3.22614 134.487 2.43648C121.721 1.64682 108.914 3.39881 97.087 7.55267C85.2604 11.7065 74.7419 18.1473 66.3706 26.3613C57.9992 34.5752 52.0067 44.3349 48.871 54.8619C45.7353 65.389 45.5432 76.3919 48.3101 86.993C48.4299 87.4642 48.5715 87.9169 48.7022 88.4066C48.8329 88.8963 49.0289 89.5245 49.2032 90.0788C62.698 134.194 115.468 201.841 128.364 214.471Z"
                    fill={color}
                />
                <path
                    d="M128.364 214.471L130.422 215.986C132.034 214.397 134.158 212.087 136.718 209.131C150.002 193.371 162.294 177.026 173.543 160.165C187.299 139.673 200.63 116.945 207.884 97.4235L205.292 96.7306L207.84 97.5436C212.254 87.6789 214.058 77.1116 213.122 66.5901C212.187 56.0686 208.536 45.8502 202.429 36.6584C196.321 27.4665 187.905 19.5261 177.778 13.3994C167.651 7.27274 156.06 3.10955 143.825 1.20468C131.59 -0.70019 119.012 -0.300162 106.98 2.37644C94.9474 5.05304 83.7561 9.94076 74.1982 16.6935C64.6402 23.4462 56.9493 31.8988 51.67 41.4528C46.3908 51.0067 43.6523 61.4284 43.6484 71.9797C43.6546 77.193 44.3229 82.3906 45.6416 87.4825L48.3101 86.9929L49.9003 85.1451L44.0079 81.505L45.6307 87.501C45.7614 87.9814 45.903 88.4249 46.0337 88.933C46.1971 89.5058 46.3714 90.0786 46.5565 90.6699C50.0092 101.914 55.8907 114.515 62.9921 127.348C73.6922 146.295 85.6937 164.694 98.9346 182.449C104.892 190.514 110.491 197.674 115.272 203.43C120.054 209.186 123.844 213.519 126.382 216.013L128.364 218.037L130.422 216.023L128.364 214.508L130.422 212.992C128.898 211.505 126.687 209.094 124.018 205.989C109.958 189.222 97.003 171.808 85.2111 153.827C78.0879 142.999 71.1826 131.653 65.3447 120.668C59.8319 110.605 55.3074 100.173 51.8172 89.4781C51.6429 88.9515 51.4904 88.4156 51.3271 87.8613C51.1964 87.3809 51.0548 86.9374 50.935 86.4755L48.2883 86.9929L46.6872 88.8406L52.4925 92.3884L50.9676 86.4755C48.3047 76.2314 48.4996 65.6013 51.5367 55.4324C54.5738 45.2635 60.3692 35.8369 68.461 27.904C76.5528 19.9711 86.7173 13.7511 98.1443 9.73992C109.571 5.72869 121.945 4.03707 134.279 4.79988C146.613 5.5627 158.567 8.75885 169.187 14.1336C179.807 19.5084 188.801 26.9131 195.45 35.7578C202.1 44.6024 206.222 54.6423 207.488 65.0773C208.755 75.5124 207.13 86.0541 202.743 95.8622V95.9176V95.9915C194.705 117.666 178.607 144.034 163.01 166.382C155.212 177.561 147.533 187.752 141.064 195.873C137.796 199.938 134.877 203.486 132.35 206.377C129.823 209.269 127.776 211.523 126.327 212.937L128.386 214.452L130.444 212.937L128.364 214.471Z"
                    fill="white"
                />
                <line
                    x1="192"
                    y1="48"
                    x2="192"
                    y2="66"
                    stroke="#BDBDBD"
                    stroke-width="4"
                />
                <rect
                    x="81"
                    y="135"
                    width="21"
                    height="7"
                    fill="white"
                />
                <line
                    x1="122"
                    y1="96"
                    x2="122"
                    y2="7"
                    stroke="#BDBDBD"
                    stroke-width="10"
                />
                <line
                    x1="125.798"
                    y1="15.0462"
                    x2="181.947"
                    y2="45.2385"
                    stroke="#BDBDBD"
                    stroke-width="4"
                />
                <rect
                    x="114"
                    y="96"
                    width="22"
                    height="7"
                    fill="#BDBDBD"
                />
                <line
                    x1="89"
                    y1="135"
                    x2="89"
                    y2="46"
                    stroke="white"
                    stroke-width="10"
                />
                <line
                    x1="161"
                    y1="86"
                    x2="94"
                    y2="86"
                    stroke="white"
                    stroke-width="10"
                />
                <line
                    x1="92.6106"
                    y1="53.6904"
                    x2="148.929"
                    y2="83.2288"
                    stroke="white"
                    stroke-width="4"
                />
                <path
                    d="M90 47C99.2288 44.7616 118.749 33.6277 123 7"
                    stroke="white"
                    stroke-width="2"
                />
                <line
                    x1="194"
                    y1="48"
                    x2="127"
                    y2="48"
                    stroke="#BDBDBD"
                    stroke-width="10"
                />
                <line
                    x1="159"
                    y1="87"
                    x2="159"
                    y2="106"
                    stroke="white"
                    stroke-width="4"
                />
                <path
                    d="M160 85C169.229 82.7616 188.749 71.6277 193 45"
                    stroke="white"
                    stroke-width="2"
                />
            </g>
            <defs>
                <clipPath id="clip0_6_29">
                    <rect
                        width="257"
                        height="218"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default OhlPin;
